import React from 'react'
import { BRow, BCol, BTitle, BButton, BCardBody } from '@prague-digi/ui-components'
import messages from '../../../../i18n'
import bankBranch from '../../../../assets/bankBranch.svg'
import styles from './styles.scss'

interface Props {
  handleGoToBranch: Function
  translate: any
  translateHTML: any
}

export const OtherDenial = ({ translate, translateHTML, handleGoToBranch }: Props) => (
  <BCardBody dark theme="mt-4">
    <BRow>
      <BCol xs={12} theme="text-center">
        <img src={bankBranch} alt="branchIcon" className={styles.headerIcon} />
      </BCol>
    </BRow>
    <BRow theme="mt-4">
      <BCol lg={12} theme="text-center">
        <BTitle type="h4">{translateHTML(messages.FinanceProfession.otherDenial.title)}</BTitle>
      </BCol>
    </BRow>
    <BRow>
      <BCol lg={12} theme="text-center">
        <BButton
          messages={{
            message: translate(messages.FinanceProfession.otherDenial.button),
          }}
          onClick={handleGoToBranch}
          color="primary"
          testid="branchBtn"
        />
      </BCol>
    </BRow>
  </BCardBody>
)

export default OtherDenial
